import { useStore } from "../../state/state.ts";
import ModalInfoPeriode from "../../modals/modal_info_periode.tsx";
import InfoButton from "../inputs/info-button.tsx";


export function PeriodSlider() {
  const period_month = useStore((state)=>state.period_month); 
  const period_year = useStore((state)=>state.period_year); 
  const set_period = useStore((state)=>state.set_period); 
  const api_profitability_calculation = useStore((state)=>state.api_profitability_calculation);

  const min_year = new Date().getFullYear();
  const current_month = new Date().getMonth() + 1; // Projektstart frühestens aktueller Monat
  const max_year = min_year + 5;

  const month_to_string = (month:number) => {
    const month_map : Record<number, string>= {
      1: "Januar",
      2: "Februar",
      3: "März",
      4: "April",
      5: "Mai",
      6: "Juni",
      7: "Juli",
      8: "August",
      9: "September",
      10: "Oktober",
      11: "November",
      12: "Dezember"
    }
    return month_map[month];
  }

  return <div className="period-slider">
      <InfoButton label="Info zum Projektstart" modal={<ModalInfoPeriode/>}/> <label id="period-slider" className="period-slider__label">Projektstart <b>{month_to_string(period_month)} {period_year}</b></label>
      <div className="period-slider__input-container">
        <input 
        type="range"
        aria-valuetext={month_to_string(period_month) + ' ' + (period_year)}
        aria-describedby="period-slider" className="period-slider__input"
        step={1}
        min={0}
        max={(max_year - min_year) * 12}
        value={(period_year - min_year) * 12 + (period_month - 1)}
        onChange={(event)=>{
          let value : number = parseInt(event.target.value);
          if (value < current_month - 1) value = current_month - 1; // Projektstart nicht vor aktuellem Monat zurückdrehbar
          let year = Math.floor(value / 12) + min_year;
          let month = (value % 12) + 1;
          set_period(month, year);
          api_profitability_calculation();
        }}/>
        <div className="period-slider__ticks">
          {[...Array(max_year - min_year).keys()].map((i)=><div className="period-slider__tick">
            {period_year == min_year + i ? <b>{min_year + i}</b> : min_year + i}
          </div>)}
        </div>
      </div>
    </div>
}